import { render, staticRenderFns } from "./ChatContainerComponent.vue?vue&type=template&id=557da0d0&scoped=true"
import script from "./ChatContainerComponent.vue?vue&type=script&lang=js"
export * from "./ChatContainerComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatContainerComponent.vue?vue&type=style&index=0&id=557da0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557da0d0",
  null
  
)

export default component.exports